import { setVh } from "@/mono/lib/styles/mixins";
import styled from "styled-components";
import ServicePageHero from "../service/ServicePageHero";

export default function WhatWeDoHero() {
  return (
    <ServicePageHero
      header="Merkidentiteit ontwikkelen - jouw merk, jouw fundament."
      paragraph={`
          **Waarom blijven klanten terugkomen? Door een merk dat indruk maakt.**
          Wil jij dat jouw merk opvalt en impact maakt? Ontdek hoe een sterke merkidentiteit deuren opent naar meer klanten, vertrouwen en groei.
        `}
      title="What we do"
      cta={{
        text: "Contact",
        href: "/contact",
      }}
    />
  );
}

const Wrapper = styled.div`
  height: ${setVh(100)};
`;
